<template>
<div id="circleprogressbar">
	<div class="circle-progress">
    <svg viewBox="0 0 360 360" class="progress-ring">
      <!-- Фоновый круг -->
      <circle
        class="progress-ring__bg"
        cx="180"
        cy="180"
        r="160"
      />
      <!-- Активный круг -->
      <circle
        class="progress-ring__bar"
        cx="180"
        cy="180"
        r="160"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference - progress * circumference"
      />
    </svg>
  </div>
</div>
</template>

<style scoped lang="sass">
.circle-progress
	position: relative
	width: 100%
	height: 100%
	


.progress-ring
	transform: rotate(-90deg)
	width: 100%
	height: 100%


.progress-ring__bg
	fill: none
	stroke: srgba(--neutral-grad-2, 0.3)
	stroke-width: 0.5em

	
.progress-ring__bar
	fill: none
	stroke: srgba(--neutral-grad-0, 0.7)
	stroke-width: 0.5em
	stroke-linecap: round
	transition: stroke-dashoffset 0.3s ease
</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'circleprogressbar',
	props: {
		progress: {
			type: Number,
			default: 0, // от 0 до 1
		},

	},
	computed: mapState({
		auth: state => state.auth,
		circumference : function(){

			const radius = 160

			return 2 * Math.PI * radius
		}
	}),

	methods: {

	},
}
</script>
